import classNames from 'classnames';
import Image from 'next/image';
import { forwardRef } from 'react';
import { ImageShape } from '@/shared/lib/types';
import Typografed from '../../shared/Typografed';

type Props = React.HTMLAttributes<HTMLElement> & {
    properties: {
        title?: string | null;
        images?: ImageShape[] | null;
    };
};

const ConstructorCompanies = forwardRef<HTMLDivElement, Props>(({ properties: { title, images }, ...props }, ref) => {
    return (
        <div ref={ref} {...props} className={classNames('constructor-block constructor-company', props.className)}>
            <div className="constructor-company-title text-m">{title && <Typografed>{title}</Typografed>}</div>
            {images?.length && (
                <div className="companies-list">
                    {images.map((image, i) => (
                        <div className="company-item" key={i}>
                            <img src={image.src} alt={image.alt || ''} loading="lazy" decoding="async" />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
});

ConstructorCompanies.displayName = 'ConstructorCompanies';

export default ConstructorCompanies;
